import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '开户信息'
  }, {
    componentType: 'el-select',
    componentName: '下拉选择',
    fieldKey: 'type',
    fieldName: '类型',
    url: 'UserPayType',
    selectType: 1,
    option: []
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'branchName',
    fieldName: '账户昵称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'account',
    fieldName: '账号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'content',
    fieldName: '备注'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierId',
    fieldName: '供应商ID'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'id',
    fieldName: '主键ID'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createUser',
    fieldName: '创建人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'updateUser',
    fieldName: '修改人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createTime',
    fieldName: '创建时间'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'updateTime',
    fieldName: '申请时间',
    width: 160
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '状态'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'originId',
    fieldName: '源ID'
  }
]
